import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import ManorIntro from './pages/manor/ManorIntro';
import ManorMain from './pages/manor/ManorMain';
import ManorBegin from './pages/manor/ManorBegin';
import ManorHome from './pages/manor/ManorHome';
import ManorStage1 from './pages/manor/ManorStage1';
import ManorStage2 from './pages/manor/ManorStage2';
import ManorStage3 from './pages/manor/ManorStage3';
import ManorStage4 from './pages/manor/ManorStage4';
import ManorStage5 from './pages/manor/ManorStage5';
import ManorThankyou from './pages/manor/ManorThankyou';

// Redirect to the intro but keep ?otp=…&role=… / ?demo=… so a refresh can log in again.
function ToIntro() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/manor', search }} replace />;
}

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route index element={<ToIntro />} />
        <Route path="/login" element={<ToIntro />} />
        <Route path="/manor" element={<ManorIntro />} />
        <Route path="/manor/main" element={<ManorMain />} />
        <Route path="/manor/begin" element={<ManorBegin />} />
        <Route path="/manor/home" element={<ManorHome />} />
        <Route path="/manor/stage1" element={<ManorStage1 />} />
        <Route path="/manor/stage2" element={<ManorStage2 />} />
        <Route path="/manor/stage3" element={<ManorStage3 />} />
        <Route path="/manor/stage4" element={<ManorStage4 />} />
        <Route path="/manor/stage5" element={<ManorStage5 />} />
        <Route path="/manor/thankyou" element={<ManorThankyou />} />
        <Route path="*" element={<ToIntro />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
